<script>
  import { configStore } from "../../../stores/config.store";

  import Icon from "../../../components/Icon/Icon.svelte";
  import get from "get-value";
  import { get as get_store } from "svelte/store";
  import { showHideSelect } from "./header.func";
  import SearchSelect from "../../../components/SearchSelect/SearchSelect.svelte";
  import { zobrazDataNaMape } from "../../../helpers/map";
  import { otvorPopup } from "../../../helpers/popup";
  import Diacritics from "diacritic";

  import {
    volbaTypuVyhladavania,
    vyhladajVyraz,
    createLabel,
  } from "./search.func";

  let vyberVyhladavaniaKod = get(
    get_store(configStore),
    "vyhladavania.typy.0.kod_ikonky",
    "001"
  );
</script>

<div class="header__header">
  <!-- Input search start -->

  <SearchSelect
    inputId="search"
    searchFunction={vyhladajVyraz}
    labelFunction={createLabel}
    inputClassName=""
    dropdownClassName="select__list autocomplete-search"
    className="input__group input__group--search"
    placeholder={get(
      get_store(configStore),
      "vyhladavania.typy.0.placeholder",
      ""
    )}
    vyhladavanie_id={get(get_store(configStore), "vyhladavania.typy.0.id", "")}
    keywordsCleanFunction={(keyword) => Diacritics.clean(keyword)}
    textCleanFunction={(keyword) => Diacritics.clean(keyword)}
    beforeChange={async (o, n) => {
      await zobrazDataNaMape(n);
      otvorPopup(n.gistyp || n.typ, n.id, n.title, n.typ);
    }}
    showSearchIcon="true"
    minCharactersToSearch="1"
    autoHide="true"
  />

  <!-- Input search end -->

  <!-- Input select start -->
  <div class="select input__group vyber-vyhladavania" on:click={showHideSelect}>
    <div
      class="select__header color__bg--{get(
        get_store(configStore),
        'vyhladavania.typy.0.kod_farby'
      )}"
      id="vyberVyhladavania"
    >
      <div class="select__label">
        <div class="select__label-wrapper">
          <svelte:component this={Icon} kod={vyberVyhladavaniaKod} />
          <!-- <Icon kod="{get( get_store( configStore ), 'vyhladavania.typy.0.kod_ikonky', [] )}" /> -->
        </div>
        <span class="select__text"
          >{get(get_store(configStore), "vyhladavania.typy.0.nazov", [])}</span
        >
      </div>
      <Icon kod="003" />
    </div>

    <div class="select__body">
      <ul class="select__list">
        {#each get(get_store(configStore), "vyhladavania.typy", []) as vyhladavanie}
          <li
            vyhladavanie-id={vyhladavanie.id}
            on:click={volbaTypuVyhladavania}
          >
            <Icon
              kod={vyhladavanie.kod_ikonky}
              svg-color-class="color__text--{vyhladavanie.kod_farby}"
            />
            <span class="color__text--{vyhladavanie.kod_farby}"
              >{vyhladavanie.nazov}</span
            >
          </li>
        {/each}
      </ul>
    </div>
  </div>
  <!-- Input select end -->
</div>

<style>
  .header__header {
    width: 60%;
  }
  .vyber-vyhladavania {
    width: 36%;
  }

  @media only screen and (max-width: 75em) {
    .header__header,
    .vyber-vyhladavania {
      width: 100%;
    }
  }
</style>
